<template>
  <div>
    <div style="padding-left: 30px; padding-right: 30px;">
      <div class="col-lg-12 col-xl-8">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterContract"
        />
      </div>

      <div style="margin-top: 8px;">
        <b-table
          responsive
          show-empty
          :empty-text="$t('no_service_contracts_were_found')"
          ref="table"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="serviceContractsProvider"
          :fields="fields"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>

          <template v-slot:cell(contractId)="data">
            <a
              v-on:click="contractClick(data.item.contractId)"
              class="row-link"
            >{{data.item.contractId}}</a>
          </template>

          <template v-slot:cell(startDate)="data">{{getDateFormatted(data.item.startDate)}}</template>

          <template v-slot:cell(endDate)="data">{{getDateFormatted(data.item.endDate)}}</template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              v-if="totalRows > 0"
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>
          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'ServiceObjects',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'service_contracts',
      filter: this.getFilter(this, 'sc-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'sc-sortBy', 'contractId'),
      sortDesc: this.getSortDesc(this, 'sc-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'sc-currentPage', 1),
      perPage: this.getPerPage(this, 'sc-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  methods: {
    filterContract(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'sc-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters, 'serviceContracts');

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'sc-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'sc-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var url = this.getServiceUr(
        'servicecontracts',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(
          ctx.sortBy,
          ctx.sortDesc,
          'serviceContracts'
        )
      );

      this.setSortBy(this, 'sc-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'sc-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'sc-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'sc-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    contractClick: function(contractNr) {
      this.$router.push({
        name: 'service-contract',
        params: { id: contractNr }
      });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'sc-perPage', this.perPage);
    },
    getDateFormatted: function(date) {
      return date === null || date === ''
        ? ''
        : this.$moment(date).format('DD/MM/YYYY');
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 320;

  var maxRows = tableHeight / 40;

  if (maxRows < 3) {
    return 5;
  }

  return Math.floor(maxRows);
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'sc-filter');

  const filterDefinition = [
    { id: 'contractId', value: '', type: 'input' },
    {
      id: 'contractType',
      value: '',
      type: 'dropdown',
      page: 'serviceContracts'
    }
  ];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'contractId',
      label: context.$t('contractId'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'contractType',
      label: context.$t('contractType'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'startDate',
      label: context.$t('start'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'endDate',
      label: context.$t('end'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    }
  ];
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>
